import React from 'react';

import styles from './EmailOptionCard.module.css';

const EmailOptionCard = ({
  email = '',
  isRecommended = false,
  isSelected = false,
  label = '',
  onSelect = () => { },
  recommendedLabel = '',
}) => (
  <button
    aria-checked={isSelected}
    className={styles.card}
    data-isselected={isSelected}
    onClick={onSelect}
    role="radio"
    type="button"
  >
    <div aria-hidden="true" className={styles.radio}>
      <div className={styles.radioDot} />
    </div>

    <div className={styles.content}>
      <span className={styles.label}>{label}</span>

      <span className={styles.email}>{email}</span>
    </div>

    {isRecommended && (
      <span className={styles.recommended}>
        {recommendedLabel}
      </span>
    )}
  </button>
);

export { EmailOptionCard };
